// 用户角色：user / reviewer / admin
export const UserRoleArray = ["user", "reviewer", "admin"] as const;

export type UserRole = (typeof UserRoleArray)[number];

// 复盘状态标签
export const ReviewStateLabelMap: Record<(typeof ReviewStateArray)[number], string> = {
  queued: "队列中",
  cancelled: "已取消",
  rejected: "已拒绝",
  reviewed: "已复盘",
  reviewing: "复盘中",
};

// 复盘状态：队列中 / 已取消 / 已拒绝 / 已复盘 / 复盘中
export const ReviewStateArray = [
  "queued",
  "cancelled",
  "rejected",
  "reviewed",
  "reviewing",
] as const;

// 投稿类型：复盘 / 开庭 / 鉴挂
export const ReviewTypeArray = ["review", "trial", "detect"] as const;

// 投稿类型标签
export const ReviewTypeLabelMap: Record<(typeof ReviewTypeArray)[number], string> = {
  review: "复盘",
  trial: "开庭",
  detect: "鉴挂",
};

// 可见性：
//   only-reviewer：仅复盘者可见
//   public-requested：请求公开后，所有用户都可以看到
//   public：确认公开后，所有用户都可以看到
export const ReviewRequestVisibilityArray = [
  "only-reviewer",
  "public-requested",
  "public",
] as const;

export const AvailableMaps = [
  "mp_rr_canyonlands_hu",
  "mp_rr_desertlands_hu",
  "mp_rr_desertlands_mu3",
  "mp_rr_district",
  "mp_rr_divided_moon_mu1",
  "mp_rr_olympus_mu2",
  "mp_rr_olympus_mu3",
  "mp_rr_tropic_island_mu1_storm",
  "mp_rr_tropic_island_mu1",
  "mp_rr_tropic_island_mu2",
] as const;

export const GameMapNameMap = {
  mp_rr_canyonlands_hu: "诸王峡谷",
  mp_rr_desertlands_hu: "世界边缘",
  mp_rr_desertlands_mu3: "世界边缘",
  mp_rr_district: "电力区",
  mp_rr_divided_moon_mu1: "破碎月亮",
  mp_rr_olympus_mu2: "奥林匹斯",
  mp_rr_olympus_mu3: "奥林匹斯",
  mp_rr_tropic_island_mu1_storm: "风暴点",
  mp_rr_tropic_island_mu1: "风暴点",
  mp_rr_tropic_island_mu2: "风暴点",
};

export const RankedTiers = [
  "Bronze",
  "Silver",
  "Gold",
  "Platinum",
  "Diamond",
  "Master",
  "Predator",
] as const;

export const RankedTierIconsMap = {
  Bronze: "/images/ranked-tier-icons/bronze.webp",
  Silver: "/images/ranked-tier-icons/silver.webp",
  Gold: "/images/ranked-tier-icons/gold.webp",
  Platinum: "/images/ranked-tier-icons/platinum.webp",
  Diamond: "/images/ranked-tier-icons/diamond.webp",
  Master: "/images/ranked-tier-icons/master.webp",
  Predator: "/images/ranked-tier-icons/predator.webp",
} satisfies Record<(typeof RankedTiers)[number], string>;

export const RankedTierNameMap = {
  Bronze: "青铜",
  Silver: "白银",
  Gold: "黄金",
  Platinum: "铂金",
  Diamond: "钻石",
  Master: "大师",
  Predator: "猎杀",
};

export type RankedTier = (typeof RankedTiers)[number];

export const ResultOk = Object.freeze({ ok: true });

// 邀请好友注册，且好友完成首次复盘 获得奖励
export const ReferralFirstTimeReviewedReward = 15n;
// 使用邀请码注册获得奖励
export const ReferredReward = 15n;

// 最好是不要改这个。
export const ApplicationCost = 50n;
export const RegistrationReward = 50n;

export const kBehindProxy = true;
export const kIsUnderMaintenance = false;
